// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_list__d9Hpw {
  list-style-type: lower-alpha; }
  .styles_list__d9Hpw li::marker {
    font-style: italic;
    font-weight: 100; }
  .styles_list__d9Hpw li {
    font-weight: 200; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/List/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,4BAA4B,EAAA;EADhC;IAIQ,kBAAkB;IAClB,gBAAgB,EAAA;EALxB;IAQQ,gBAAgB,EAAA","sourcesContent":[".list {\n    list-style-type: lower-alpha;\n    li::marker {\n        // font-size: 5rem;\n        font-style: italic;\n        font-weight: 100;\n    }\n    li {\n        font-weight: 200;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `styles_list__d9Hpw`
};
export default ___CSS_LOADER_EXPORT___;
